import React from"react";
import ReactDOM from"react-dom/client";
import"./index.css";

// 환경 변수에 따라 다른 앱 로드
const ENGINE_TYPE = process.env.REACT_APP_ENGINE_TYPE || 'default';

let App;
if (ENGINE_TYPE === 'T5') {
  App = require('./AppT5').default;
} else if (ENGINE_TYPE === 'H8') {
  App = require('./AppH8').default;
} else {
  // 기본 앱 (제품 선택 포함)
  App = require('./App').default;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
